import styled from "@emotion/styled";

export const StyledDiv = styled.div`
    
`;

export const StyledBorderDiv = styled.div`
    border-top: 1px solid #0505054a;
`

export const StyledSpaceBetween = styled.div`
    display: flex;
    justify-content: space-between;
`

export const StyledFlex = styled.div`
    display: flex;
`
export const StyledFlexEnd = styled.div`
    display: 'flex';
    justifyContent: 'flex-end'
`;

export const StyledFlexCenter = styled.div`
    display: flex;
    justify-content: center;
    width: 33%;
    text-align: center;
    margin: auto;
`;


export const StyledFlexStart = styled.div`
    display: 'flex';
    justifyContent: 'flex-start'
`;

export const StyledChatContainer = styled.div`
    display: flex;
    flex-direction: column;
    height: calc(100vh - 102px);
    overflow: hidden;
    // background-color: #f5f5f5;
`;